// extracted by mini-css-extract-plugin
export default {"emergencyServiceCard":"EmergencyService_emergencyServiceCard__cmGj9","emergencyServiceCardImage":"EmergencyService_emergencyServiceCardImage__iZsMX"};